module.exports = __webpack_public_path__ + "static/media/hero-bcg3.a51958d9.jpg";